<template>
  <p>
    <span :class="`${appendedClass} rtl:ml-1 ltr:mr-1`">{{ (isExpanded || !needsTruncate) ? text : trimmedText }}</span>
    <slot v-if="needsTruncate" name="toggle-button" :is-expanded="isExpanded" :toggle="toggleText">
      <!-- Default button if no slot content is provided -->
      <button @click="toggleText" class="default-btn">
        {{ isExpanded ? $t('general.show_less') : $t('general.show_more') }}
      </button>
    </slot>
  </p>
</template>

<script setup>
import { ref, computed } from "vue";

// Props
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  limit: {
    type: Number,
    default: 100,
  },
  addTruncateLabel: {
    type: Boolean,
    default: true,
    required: false,
  },
  appendedClass: {
    type: String,
    required: false,
    default: "",
  },
});

const isExpanded = ref(false);
const needsTruncate = computed(() => props.text.length > props.limit);

const trimmedText = computed(() => {
    return needsTruncate.value ? `${props.text.slice(0, props.limit)}  ${props.addTruncateLabel ? "..." : ""}` : props.text;
});

const toggleText = () => {
  isExpanded.value = !isExpanded.value;
};
</script>

<style scoped>
.default-btn {
  color: #3498db;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-left: 8px;
  text-decoration: underline;
}

.default-btn:hover {
  text-decoration: none;
}
</style>
